<template lang="pug">
	.actions-dropdown(ref="elem" v-pseudo-modal-show="type + '-actions-dropdown-' + index" @click="setPosition($event)")
		i.fa.fa-ellipsis-v
		.dropdown-menu(v-pseudo-modal="type + '-actions-dropdown-' + index" :style="{top: topY + 'px', left: leftX + 'px'}")
			.dropdown-item(@click="editItem")
				span Edit
			.dropdown-item(@click="deleteItem")
				span Delete
</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'ActionsDropdown',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {}
	},
	props: ["type", "index", "campaign", "order"],
	data() {
		this.topY = 0;
		this.leftX = 0;
		return {
			showed: true
		}
	},
	created() {
	},
	mounted() {

	},
	methods: {
		collectData() {},
		setPosition(event) {
			let target = this.$refs.elem;
			let left = event.clientX;
			let top = 0;
			top = target.getBoundingClientRect().top;
			left = target.getBoundingClientRect().right;
			this.topY = top;
			if (window.innerWidth - left <= 180) left = window.innerWidth - 180;
			this.leftX = left;
			this.$forceUpdate();
		},

		editItem() {
			if (this.type === 'campaign') {
				Broadcast.call("Show CampaignActionsEdit", [this.campaign]);
			} else if (this.type === 'order') {
				Broadcast.call("Show OrderActionsEdit", [this.order]);
			}
		},
		deleteItem() {
			if (this.type === 'campaign') {
				Broadcast.call("Show CampaignActionsDelete", [this.campaign]);
			} else if (this.type === 'order') {
				Broadcast.call("Show OrderActionsDelete", [this.order]);
			}
		}
	}
}

</script>

<style lang="sass">

	.actions-dropdown
		height: 40px
		width: 40px
		font-size: 30px
		display: flex

		>i
			margin: auto
			cursor: pointer

		>.dropdown-menu
			display: block
			position: absolute
			width: 160px
			background-color: #3F404C
			color: white
			border: unset
			border-radius: 10px

			>.dropdown-item
				cursor: pointer
				color: white
				margin: 10px 0 10px 0
				border: unset
				border-radius: unset
				font-size: 14px
				padding: 5px 0 5px 10px
				background-color: #565761

				&:hover
					background-color: #AAA1F5
					color: #B86354

			//left: 0
			//top: 0

</style>
